import { CampaignSnsRequirementSnsType, Influencer, Provider } from '~/generated/graphql'
import { CampaignSnsRequirementSnsKind } from '~/lib/types/Campaign'

export type SnsConnectionKeys = keyof Omit<NonNullable<Influencer['activeSnsConnections']>, '__typename'>

export const SNS_CONNECTION_TYPE: Record<Provider, SnsConnectionKeys> = {
  GOOGLE_OAUTH2: 'youtube',
  TIKTOK: 'tiktok',
  INSTAGRAM: 'instagram',
  TWITTER: 'twitter',
} as const

export const SNS_TYPE: Record<CampaignSnsRequirementSnsType, CampaignSnsRequirementSnsKind> = {
  YOUTUBE: 'youtube',
  TIKTOK: 'tiktok',
  INSTAGRAM: 'instagram',
  TWITTER: 'twitter',
  NO_SETTINGS: 'no_settings',
} as const

export const SNS_LABEL: Record<SnsConnectionKeys, string> = {
  instagram: 'Instagram',
  twitter: 'X',
  youtube: 'YouTube',
  tiktok: 'TikTok',
} as const

export const Campaign_SNS_LABEL: Record<CampaignSnsRequirementSnsType, string> = {
  [CampaignSnsRequirementSnsType.Instagram]: 'Instagram',
  [CampaignSnsRequirementSnsType.Twitter]: 'X',
  [CampaignSnsRequirementSnsType.Youtube]: 'YouTube',
  [CampaignSnsRequirementSnsType.Tiktok]: 'TikTok',
  [CampaignSnsRequirementSnsType.NoSettings]: '',
} as const
